import Enum from './enum'

/**
 * レポクラフト/レポクラフト「無地」 評価機能
 */
class RepocraftEvaluation extends Enum {
    static ON = 1; // 使用する
    static OFF = 9; // 使用しない

    static values() {
        return {
            [this.ON]: '使用する',
            [this.OFF]: '使用しない',
        }
    }
}

export default RepocraftEvaluation;
